'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var key = require('interface-datastore/key');

var MFS_ROOT_KEY = new key.Key('/local/filesroot');

function storeMfsRootInDatastore(_x) {
  return _storeMfsRootInDatastore.apply(this, arguments);
}

function _storeMfsRootInDatastore() {
  _storeMfsRootInDatastore = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(backends) {
    var onProgress,
        root,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            onProgress = _args.length > 1 && _args[1] !== undefined ? _args[1] : function () {};
            onProgress(100, 'Migrating MFS root to repo datastore');
            _context.next = 4;
            return backends.root.open();

          case 4:
            _context.next = 6;
            return backends.datastore.open();

          case 6:
            _context.next = 8;
            return backends.root.has(MFS_ROOT_KEY);

          case 8:
            if (!_context.sent) {
              _context.next = 16;
              break;
            }

            _context.next = 11;
            return backends.root.get(MFS_ROOT_KEY);

          case 11:
            root = _context.sent;
            _context.next = 14;
            return backends.datastore.put(MFS_ROOT_KEY, root);

          case 14:
            _context.next = 16;
            return backends.root.delete(MFS_ROOT_KEY);

          case 16:
            _context.next = 18;
            return backends.datastore.close();

          case 18:
            _context.next = 20;
            return backends.root.close();

          case 20:
            onProgress(100, 'Stored MFS root in repo datastore');

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _storeMfsRootInDatastore.apply(this, arguments);
}

function storeMfsRootInRoot(_x2) {
  return _storeMfsRootInRoot.apply(this, arguments);
}

function _storeMfsRootInRoot() {
  _storeMfsRootInRoot = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(backends) {
    var onProgress,
        root,
        _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            onProgress = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : function () {};
            onProgress(100, 'Migrating MFS root to repo root datastore');
            _context2.next = 4;
            return backends.root.open();

          case 4:
            _context2.next = 6;
            return backends.datastore.open();

          case 6:
            _context2.next = 8;
            return backends.datastore.has(MFS_ROOT_KEY);

          case 8:
            if (!_context2.sent) {
              _context2.next = 16;
              break;
            }

            _context2.next = 11;
            return backends.datastore.get(MFS_ROOT_KEY);

          case 11:
            root = _context2.sent;
            _context2.next = 14;
            return backends.root.put(MFS_ROOT_KEY, root);

          case 14:
            _context2.next = 16;
            return backends.datastore.delete(MFS_ROOT_KEY);

          case 16:
            _context2.next = 18;
            return backends.datastore.close();

          case 18:
            _context2.next = 20;
            return backends.root.close();

          case 20:
            onProgress(100, 'Stored MFS root in repo root datastore');

          case 21:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _storeMfsRootInRoot.apply(this, arguments);
}

var migration = {
  version: 11,
  description: 'Store mfs root in the datastore',
  migrate: storeMfsRootInDatastore,
  revert: storeMfsRootInRoot
};
exports.migration = migration;